
export default function parseUnit (input) {
  try {
    var output = []
    for (let k = 0; k < input.length; k++) {
      let item = input[k]
      let tierArray = item.tier.replace(/ /g, '').split(',')
      var floors = []
      var floor = item.floor
      var floorWoSpace = floor.split(' ').join('')
      var floorArray = floorWoSpace.split(',')
      for (let i = 0; i < floorArray.length; i++) {
        if (floorArray[i].includes('-')) {
          var floorFrom = (floorArray[i].split('-'))[0]
          var floorTo = (floorArray[i].split('-'))[1]
          if (parseInt(floorFrom) < parseInt(floorTo)) {
            let floorDiffer = parseInt(parseInt(floorTo) - parseInt(floorFrom)) + 1
            for (let j = 0; j < floorDiffer; j++) {
              floors.push(floorFrom)
              floorFrom = (parseInt(floorFrom) + 1).toString()
            }
          } else {
            let floorDiffer = parseInt(parseInt(floorFrom) - parseInt(floorTo)) + 1
            for (let j = 0; j < floorDiffer; j++) {
              floors.push(floorTo)
              floorTo = (parseInt(floorTo) + 1).toString()
            }
          }
        } else {
          floors.push(floorArray[i])
        }
      }
      var floorsWoDup = []
      for (let i = 0; i < floors.length; i++) {
        if ((floors.slice(i + 1, floors.length)).indexOf(floors[i]) === -1) {
          floorsWoDup.push(floors[i])
        }
      }
      var tempFloors = []
      for (let i = 0; i < floorsWoDup.length; i++) {
        if (floorsWoDup[i].toString() !== '') {
          tempFloors.push(floorsWoDup[i])
        }
      }
      floorsWoDup = tempFloors
      floorsWoDup.sort(function (a, b) { return parseInt(a) - parseInt(b) })
      for (let i = 0; i < floorsWoDup.length; i++) {
        for (var m = 0; m < tierArray.length; m++) {
          let tier = tierArray[m]
          // remove the prefix zero of the tier
          while (tier[0] === '0' && tier.length > 1) {
            tier = tier.slice(1)
          }
          if (item.type !== 'Other') {
            let display = ''
            if (tier.length < 2) {
              display = floorsWoDup[i].toString() + '0' + tier
            } else {
              display = floorsWoDup[i].toString() + tier
            }
            if (item.building !== 'Default') {
              display = display + '(' + item.building + ')'
            }
            let outputItem = {
              building: item.building,
              tier: tier,
              floor: floorsWoDup[i],
              type: item.type,
              display: display
            }
            output.push(outputItem)
          } else {
            let display = ''
            if (tier.length < 2) {
              display = floorsWoDup[i].toString() + '0' + tier
            } else {
              display = floorsWoDup[i].toString() + tier
            }
            let outputItem = {
              building: item.building,
              tier: tier,
              floor: floorsWoDup[i],
              type: item.other_type,
              display: display
            }
            output.push(outputItem)
          }
        }
      }
    }
    return output
  } catch (err) {
    console.warn(err)
    return 'error'
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/parseUnit.js
// module id = null
// module chunks = 